<template>
    <generic-task-execution-modal
        :asset="asset"
        :assignable-users="assignableUsers"
        :description="description"
        :form="form"
        :task-resolved="taskResolved"
        :primary-button-label="taskResolved ? trans('tasks.modal.awaiting_approval.save_changes') : trans('general.action.submit')"
        :editable="editable"
        :task-code="taskCode"
        :task-group="taskGroup || 'performance_data'"
        :task-id="taskId"
        :title="title"
        @submit="handleSubmit"
    >
        <jet-select
            v-model="form.task_type"
            :disabled="!editable"
            :horizontal="{ label: 'col-md-3', input: 'col-md-9' }"
            :invalidFeedback="form.errors.type"
            :label="trans('qa.configuration.type.performance_data.title')"
            :options="types.data || []"
            :readonly="!!performanceData?.id || types.data.length <= 1"
            :required="true"
            formGroupClasses="mb-9"
        />
        <jet-input
            v-model="form.value"
            :disabled="!editable"
            :horizontal="{ label: 'col-md-3', input: 'col-md-9' }"
            :invalidFeedback="form.errors.value"
            :required="true"
            formGroupClasses="mb-9"
            label="Value"
            name="value"
        />
    </generic-task-execution-modal>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import { useForm } from '@inertiajs/vue3';
import { trans } from '@/mixins/i18n';
import JetInput from '@/Jetstream/Input.vue';
import JetSelect from '@/Jetstream/Select.vue';

const GenericTaskExecutionModal = defineAsyncComponent(() => import('@/Pages/Modals/GenericTaskExecutionModal.vue'));

const props = defineProps({
    asset: {
        type: Object,
        required: true,
    },
    types: {
        type: Object,
        required: true,
    },
    performanceData: {
        type: Object,
        required: false,
    },
    currentUserId: String,
    assignableUsers: Object,
    taskId: String,
    taskCode: String,
    taskType: String,
    taskGroup: String,
    assetId: String,
    title: String,
    description: String,
    editable: {
        type: Boolean,
        default: true,
    },
    links: Object,
    existingPerformedById: String,
    taskResolved: { type: Boolean, default: false },
});

const form = useForm({
    value: props.performanceData?.value ?? null,
    performedById: props.existingPerformedById ?? props.currentUserId,
    attachments: [],
    taskId: props.taskId,
    task_type: props.taskType,
    asset_id: props.assetId,
    description: null,
});

const handleSubmit = (modal) => {
    form.post(props.links.create, {
        preserveScroll: true,
        onSuccess: () => {
            modal.close();
        },
    });
};
</script>
